export default __webpack_public_path__ + "static/media/por.7744640e.svg";